module.exports = __webpack_public_path__ + "static/media/slackEmoji7.aba9e034.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/slackEmoji7.gif
// module id = 41
// module chunks = 0